module.exports = __webpack_public_path__ + "static/media/md-star-half.c45a1565.svg";